export const APP_VERSION = 'v0.1.40';
